module.exports = __webpack_public_path__ + "static/media/thumbnail_endosee-for-use@2x.f11626a2.jpg";